import { DateType } from 'api/models';
import { ProjectBulkMergeResult, ProjectPhase } from 'api/project';
import { Task } from 'api/tasks';
import { ProjectTemplateApi } from 'data/templates/projects';
import { byStartDate } from 'utils/comparators/by-start-date';
import { TableRecord } from './columns';

type Phase = ProjectPhase & { templateName?: string };
type Child = {
  key: string;
  name: string;
  startDate?: DateType | null;
};

type ToChildrenFn = (task: Task, index: number) => Child;

const toChildren: ToChildrenFn = ({
  taskName,
  startDate,
  taskId,
  subTasks,
}) => ({
  key: taskId.toString(),
  name: taskName,
  startDate,
  children: subTasks && subTasks.length > 0 ? subTasks.map(toChildren) : [],
});

export const toTableDataSource =
  (lookup: Record<string, ProjectTemplateApi>) =>
  (input: ProjectBulkMergeResult[] = []): TableRecord[] => {
    const phases: Phase[] = input.reduce((prev, { source, projectPhases }) => {
      return [
        ...prev,
        ...projectPhases.map((phase) => ({
          ...phase,
          templateName: lookup[source.sourceId]?.templateName,
        })),
      ];
    }, [] as ProjectPhase[]);

    return phases
      .map(
        ({
          projectPhaseId,
          projectPhaseName,
          startDate,
          tasks,
          templateName,
        }) => {
          const results = tasks.map(toChildren);
          const children = results.sort(byStartDate);

          return {
            key: projectPhaseId,
            name: projectPhaseName,
            startDate,
            templateName,
            children,
          };
        },
      )
      .sort(byStartDate);
  };
